export default "__VITE_ASSET__CszznPEW__"